import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Admlayout from "../components/admlayout";

const AdminPrivateRoute = () => {
    const auth = JSON.parse(localStorage.getItem("authAdm"));
    const location = useLocation();

    const isAuthorized = auth && auth.authorized && (auth.type === "admin" || auth.type === "teacher");

    if (!isAuthorized) {
        return (
            <Admlayout>
                <Navigate to={`/adm/admlogin?redirect=${encodeURIComponent(location.pathname)}`} replace />
            </Admlayout>
        );
    }

    return (
        <Admlayout>
            <Outlet />
        </Admlayout>
    );
};

export default AdminPrivateRoute;
